import { EventType } from './event-type.interface';

export const REMOTE_BUTTON: EventType = {
  name: 'Button',
  description: 'When a system remote custom button is pressed in a room',
  route: 'buttons/remotes',
  category: 'Buttons',
  icon: 'remote',
  order: 2,
  whitelist: [
    {
      proxy: 'control4_sr260',
      events: []
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/remote-button.type.ts